import { useEffect } from 'react';
import Content from './Content';
import Footer from './Footer';
import Header from './Header';
import styles from './index.module.scss';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { AgentTrackingEvents } from '@cp/src/service/clickStream.constant';

const LonghornBlock = () => {
  useEffect(() => {
    addClickstreamEvent(AgentTrackingEvents.LH_COSMOS_SYNC_AGENT_BLOCKED);
  }, []);

  return (
    <div className="flex justify-center items-center h-[100%] flex-col mt-[64px]">
      <div className={styles.cardContainer}>
        <Header />
        <Content />
        <Footer />
      </div>
    </div>
  );
};

export default LonghornBlock;
